var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    stroke: "#B0A8AA",
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52319 9.53302C6.29605 9.58017 6.07319 9.62302 5.85034 9.67017C5.37462 9.76874 5.38319 9.76874 5.37891 10.253C5.37891 10.4116 5.42605 10.4587 5.58462 10.4587C6.42034 10.4502 7.25605 10.4545 8.09176 10.4545C8.64034 10.4545 8.63605 10.4545 8.61891 9.91017C8.61462 9.79445 8.57605 9.7516 8.46462 9.73017C8.13462 9.67017 7.80891 9.59731 7.45748 9.52874C7.45748 8.22588 7.45748 6.9316 7.45748 5.62017C6.83176 5.69731 6.23176 5.77445 5.64034 5.84731C5.64034 6.08731 5.64034 6.30588 5.64034 6.54588C5.94462 6.54588 6.23605 6.54588 6.52748 6.54588C6.52319 7.55302 6.52319 8.53445 6.52319 9.53302ZM7.00319 4.69017C7.38891 4.68588 7.69319 4.37731 7.68891 3.9916C7.68462 3.62731 7.36319 3.31445 6.99891 3.31445C6.60891 3.31445 6.31319 3.61445 6.31319 4.00874C6.31319 4.41588 6.59605 4.69445 7.00319 4.69017Z",
    fill: "#B0A8AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.024a608b97aff4715f3e6f63e0185197.svg";
export { ForwardRef as ReactComponent };